export default state => {
	return state.hasEthereumProvider;
};
